"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _futuresSelectors = require("./futuresSelectors");
Object.keys(_futuresSelectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _futuresSelectors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _futuresSelectors[key];
    }
  });
});
var _futuresPositionsSelectors = require("./futuresPositionsSelectors");
Object.keys(_futuresPositionsSelectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _futuresPositionsSelectors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _futuresPositionsSelectors[key];
    }
  });
});
var _futuresProductSelectors = require("./futuresProductSelectors");
Object.keys(_futuresProductSelectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _futuresProductSelectors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _futuresProductSelectors[key];
    }
  });
});
var _futuresInstrumentsSelector = require("./futuresInstrumentsSelector");
Object.keys(_futuresInstrumentsSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _futuresInstrumentsSelector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _futuresInstrumentsSelector[key];
    }
  });
});
var _futuresTickersSelectors = require("./futuresTickersSelectors");
Object.keys(_futuresTickersSelectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _futuresTickersSelectors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _futuresTickersSelectors[key];
    }
  });
});